import { createAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../store/configureStore';

export const DEBUG_LOG = createAction<string[]>('DEBUG_LOG');

export const log =
  (...logs: string[]): AppThunk =>
  (dispatch) =>
    dispatch({
      type: 'DEBUG_LOG',
      payload: [new Date().getTime().toString()].concat(logs).map((x) => x.toString()),
    });
